<template>
    <div>
        <!--<el-upload style="display: none"
                class="upload-demo"
                drag
                action=""
                multiple>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
        </el-upload>-->
        <div class="upload" id="drop_area" :style="{'border-color': (borderhover ? '#3d8cff':'transparent')}">
            <img src="../assets/images/bug_add_upload.png" width="260">
            <div class="des-text">{{$store.state.i18n.uploadTip[$store.state.CN_EN]}}</div>
            <input id="addImageBtn" type="file" accept="image/png,image/jpeg,image/gif" class="input-up" multiple/>
        </div>
<!--        <div class="upload-tip">只能上传jpg/png文件，且不超过500kb</div>-->
        <div class="upload-tip">{{this.$store.state.i18n.uploadInfo[$store.state.CN_EN]}}</div>
        <ul class="file-list">
            <li v-for = "(item,index) in fileData">
                <img src="../assets/images/list_bug_clip.png" width="14">
                <span class="file-name">{{item.fileText}}</span>
                <i class="el-icon-close" @click="removeOne(index)"></i>
                <el-progress v-show="item.progress != null" :percentage="item.progress" status="success" :stroke-width="2"></el-progress>
            </li>
        </ul>
    </div>
</template>
<script>
    // import Client from '../assets/js/oss/Client'
    import GlobalData from '../assets/js/common/GlobalData.js'
    import Vue from 'vue'
    import {
        Message,
        Progress,
    } from 'element-ui';

    Vue.use(Progress);
    import plupload from 'plupload'
    import globalFunctions from "../assets/js/common/GlobalFunction";

    Vue.prototype.$message = Message

    //将渲染的内容导出
    export default {
        props:['parentFileData','businessType','projectId','isBuyPackage','isInvalid','storageSpaceIsUnlimited','canUseStorageSpace'],//通过props实现父组件数据到子组件的传递
        data(){
            return {
                borderhover:false,
                fileData:[],
                addUploader:null,//plupload的实例对象

                fileSize:null,
            }
        },
        methods: {
            eventDrop: function(e){
                this.borderhover = false
                e.stopPropagation();
                e.preventDefault();  //必填字段

                //========= 调用plupload插件中的上传方法 Start ==========//
                let up = this.addUploader; //plupload的实例对象
                let fileList = e.dataTransfer.files; //获取文件对象
                //检测是否是拖拽文件到页面的操作
                if (fileList.length == 0) {
                    return false;
                }
                for(let i = 0; i < fileList.length; i++)
                {
                    console.log(up);
                    //调用plupload的实例对象中的上传文件方法
                    up.addFile(fileList[i]);
                }
                //========= 调用plupload插件中的上传方法 End ==========//
            },
            removeOne:function (i) {
                this.fileData.splice(i,1);
                //将子组件的数据传给父组件
                this.$emit('getFileInfoJsonArrStr', this.fileData)
            },
            removeAll:function () {
                //清空所有
                this.fileData = []
            }
        },
        watch: {
            parentFileData: function(newVal,oldVal){
                this.fileData = newVal;  //newVal即是parentFileData
                // console.log(newVal);//这里再感受下值拿到了没
            },
            businessType:function (newVal,oldVal) {
                this.businessType = newVal
            },
            projectId:function (newVal,oldVal) {
                this.projectId = newVal
            }
        },
        mounted(){
            let _this = this;
            let dropbox = document.getElementById('drop_area');
            dropbox.addEventListener("drop",this.eventDrop,false)
            dropbox.addEventListener("dragleave",function (e) {
                e.stopPropagation();
                e.preventDefault();
                _this.borderhover =  false;
            })
            dropbox.addEventListener("dragenter",function (e) {
                e.stopPropagation();
                e.preventDefault();
                _this.borderhover =  true;
            })
            dropbox.addEventListener("dragover",function (e) {
                e.stopPropagation();
                e.preventDefault();
                _this.borderhover =  true
            })

            this.addUploader = new plupload.Uploader({
                runtimes : 'html5,flash,silverlight,html4',
                browse_button : 'addImageBtn',
                //multi_selection: false,
                // container: document.getElementById('container'),
                url : 'http://oss.aliyuncs.com',
                filters: {
                    mime_types : [ //只允许上传图片和zip文件
                        { title : "Image files", extensions : "jpg,png" },
                        { title : "Office files", extensions : "doc,docx,xls,xlsx,ppt,pptx" },
                        { title : "PDF files", extensions : "pdf" },
                        { title : "Audio files", extensions : "mp3,wav" },
                        { title : "Video files", extensions : "mp4" },
                        // { title : "Zip files", extensions : "zip,rar" }
                    ],
                    max_file_size : '100mb', //最大只能上传100mb的文件
                    prevent_duplicates : false, //true不允许选取重复文件，false允许选取重复文件
                },
                init: {
                    FilesAdded: function(up, files) {
                        console.log("FilesAdded")
                        // console.info(_this.isBuyPackage,_this.isInvalid,_this.storageSpaceIsUnlimited,_this.canUseStorageSpace,_this.parentFileData)
                        /**
                         * 在上传文件之前，优先校验当前项目的负责人所购买的套餐，是否达到使用额度
                         * businessType : BugAdd --> 新增BUG
                         * businessType : BugEdit --> 编辑BUG
                         * businessType : MissionAddOrEdit --> 新增 或 编辑任务
                         */
                        if(_this.businessType == 'BugAdd' || _this.businessType == 'BugEdit' || _this.businessType == 'MissionAddOrEdit')
                        {
                            plupload.each(files, function (file) {
                                if(_this.isBuyPackage == 0)
                                {
                                    _this.addUploader.removeFile(file);//在上传队列中移除当前不符合要求的图片
                                    _this.$message.error(_this.$store.state.i18n.productNoBuy[_this.$store.state.CN_EN]);
                                    return
                                }
                                else if(_this.isBuyPackage == 1 && _this.isInvalid == 1)
                                {
                                    _this.addUploader.removeFile(file);//在上传队列中移除当前不符合要求的图片
                                    _this.$message.error(_this.$store.state.i18n.productIsInValid[_this.$store.state.CN_EN]);
                                    return
                                }
                                else if(_this.isBuyPackage == 1 && _this.isInvalid == 0 && _this.storageSpaceIsUnlimited == 0 && file.size > _this.canUseStorageSpace)
                                {
                                    _this.addUploader.removeFile(file);//在上传队列中移除当前不符合要求的图片
                                    _this.$message.error(_this.$store.state.i18n.productStorageSpaceExceedLimit[_this.$store.state.CN_EN]);
                                    return
                                }

                                setUploadParam(up, '', false);
                            });
                        }
                        else
                        {
                            plupload.each(files, (file) => {
                                setUploadParam(up, '', false);
                            })
                        }
                    },
                    BeforeUpload: function(up, file) {
                        console.log("BeforeUpload")
                        if(_this.isBuyPackage == 0)
                        {
                            _this.addUploader.removeFile(file);//在上传队列中移除当前不符合要求的图片
                            _this.$message.error(_this.$store.state.i18n.productNoBuy[_this.$store.state.CN_EN]);
                            return
                        }
                        else if(_this.isBuyPackage == 1 && _this.isInvalid == 1)
                        {
                            _this.addUploader.removeFile(file);//在上传队列中移除当前不符合要求的图片
                            _this.$message.error(_this.$store.state.i18n.productIsInValid[_this.$store.state.CN_EN]);
                            return
                        }
                        else if(_this.isBuyPackage == 1 && _this.isInvalid == 0 && _this.storageSpaceIsUnlimited == 0 && file.size > _this.canUseStorageSpace)
                        {
                            _this.addUploader.removeFile(file);//在上传队列中移除当前不符合要求的图片
                            _this.$message.error(_this.$store.state.i18n.productStorageSpaceExceedLimit[_this.$store.state.CN_EN]);
                            return
                        }

                        setUploadParam(up, file.name, true);
                        _this.fileData.push({
                            "fileText":file.name,
                            "fileName":file.name,
                            "fileSize":file.size,
                            "filePath":host + keyMap.get(file.name),
                            "progress":0,
                        });
                    },
                    UploadProgress: function(up, file) {
                        console.log(file.percent);
                        for(var i=0; i<_this.fileData.length;i++)
                        {
                            var fileName = _this.fileData[i].fileName;
                            if(file.name == fileName && _this.fileData[i].progress != null)
                            {
                                _this.fileData[i].progress = file.percent;
                            }
                        }
                    },
                    FileUploaded: function(up, file, info) {
                        console.log("FileUploaded")
                        if (info.status == 200 || info.status == 203)
                        {
                            //203是上传回调服务器失败，失败原因
                            console.info(host + keyMap.get(file.name));
                            //将上传成功的图片封装在Vue实例中
                            /*_this.fileData.push({
                                "fileText":file.name,
                                "fileName":file.name,
                                "fileSize":file.size,
                                "filePath":host + keyMap.get(file.name)
                            });*/
                            //将子组件的数据传给父组件
                            _this.$emit('getFileInfoJsonArrStr', _this.fileData)
                        }
                        else
                        {
                            _this.$message.error(info.response);
                        }
                    },
                    Error: function(up, err) {
                        console.log(err.code);
                        if (err.code == -600)
                        {
                            _this.$message.error("选择的文件太大了,可以根据应用情况，在upload.js 设置一下上传的最大大小");
                        }
                        else if (err.code == -601)
                        {
                            _this.$message.error("选择的文件后缀不对,可以根据应用情况，在upload.js进行设置可允许的上传文件类型");
                        }
                        else if (err.code == -602)
                        {
                            _this.$message.error("这个文件已经上传过一遍了");
                        }
                        else
                        {
                            _this.$message.error(err.response);
                        }
                    }
                }
            });

            this.addUploader.init();
        },
    }

    //================== 阿里云OSS前端上传 Start =============//
    let accessid = ''
    let accesskey = ''
    let host = ''
    let policyBase64 = ''
    let signature = ''
    let filename = ''
    let key = ''
    let keyMap = new Map();
    let expire = 0
    //let g_object_name = ''
    let now = Date.parse(new Date()) / 1000;

    function send_request()
    {
        var xmlhttp = null;
        if (window.XMLHttpRequest)
        {
            xmlhttp=new XMLHttpRequest();
        }
        else if (window.ActiveXObject)
        {
            xmlhttp=new ActiveXObject("Microsoft.XMLHTTP");
        }

        if (xmlhttp!=null)
        {
            // serverUrl是 用户获取 '签名和Policy' 等信息的应用服务器的URL，请将下面的IP和Port配置为您自己的真实信息。
            let serverUrl = GlobalData.API_SERVER_BASE_URL+'/GetPolicy.html'

            xmlhttp.open( "GET", serverUrl, false );
            xmlhttp.send( null );

            console.info(xmlhttp.responseText)
            return xmlhttp.responseText
        }
        else
        {
            // noty({"text": "您的浏览器不支持XML HTTP请求，请换Chrome浏览器", "type": "error", "timeout": 4000});
            setTimeout(function(){
                alert("您的浏览器不支持XML HTTP请求，请换Chrome浏览器");
            },4000);
        }
    };

    function get_signature()
    {
        console.log("update get_signature")
        //可以判断当前expire是否超过了当前时间，如果超过了当前时间，就重新取一下，3s作为缓冲。
        let now = Date.parse(new Date()) / 1000;
        if (expire < now + 3)
        {
            let body = send_request()
            console.info(body)

            var obj = eval ("(" + body + ")");
            host = obj['host']
            policyBase64 = obj['policy']
            accessid = obj['accessid']
            signature = obj['signature']
            expire = parseInt(obj['expire'])
            // callbackbody = obj['callback']
            key = obj['dir']
            return true;
        }
        return false;
    };

    function random_string(len) {
        console.log("update random_string")

        len = len || 32;
        var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
        var maxPos = chars.length;
        var pwd = '';
        for (let i = 0; i < len; i++) {
            pwd += chars.charAt(Math.floor(Math.random() * maxPos));
        }
        return pwd;
    }

    function get_suffix(filename) {
        let pos = filename.lastIndexOf('.')
        let suffix = ''
        if (pos != -1) {
            suffix = filename.substring(pos)
        }
        return suffix;
    }

    function calculate_object_name(filename)
    {
        let date=new Date();
        let year = date.getFullYear()
        let month = date.getMonth() + 1
        month = month < 10 ? '0' + month : month
        let day = date.getDate()
        day = day < 10 ? ('0' + day) : day

        let suffix = get_suffix(filename)
        //g_object_name = key + year +"/" + month + "/" + day + "/" + random_string(20) + suffix
        keyMap.set(filename, key + year +"/" + month + "/" + day + "/" + random_string(20) + suffix);
        return ''
    }

    function setUploadParam(up, filename, ret)
    {
        if (ret == false)
        {
            ret = get_signature()
        }
        //g_object_name = key;
        if (filename != '') { let suffix = get_suffix(filename)
            calculate_object_name(filename)
        }
        let new_multipart_params = {
            'key' : keyMap.get(filename),
            'policy': policyBase64,
            'OSSAccessKeyId': accessid,
            'success_action_status' : '200', //让服务端返回200,不然，默认会返回204
            'signature': signature,
        };

        up.setOption({
            'url': host,
            'multipart_params': new_multipart_params
        });

        up.start();
    }
    //================== 阿里云OSS前端上传 End =============//
</script>
<style scoped>
    .upload{
        position: relative;
        overflow: hidden;
        display: inline-block;
        border: 1px solid transparent;
        border-radius: 4px;
    }
    .input-up{
        position: absolute;
        top: 0;
        right: 0;
        font-size: 108px;
        opacity: 0;
        cursor: pointer;
        outline: none;
    }
    .upload-tip{
        color: #666;
        font-size: 12px;
        margin: 10px 0;
    }
    .file-list li{
        padding: 5px 10px;
        border-radius: 4px;
        margin: 5px 0;
        color: #666;
        cursor: pointer;
    }
    .file-name{
        vertical-align: middle;
        margin-left: 7px;
        width: 245px;
        display: inline-block;
        word-break: break-all;
    }
    .file-list li i{
        display: none;
    }
    .file-list li:hover{
        background: #f5f7fa;
    }
    .file-list li:hover i{
        display: inline-block;
    }
    .des-text{
        color: #666666;
        position: absolute;
        top: 68px;
        width: 260px;
        text-align: center;
        font-size: 13px;
    }
</style>
